module.exports = __webpack_public_path__ + "static/media/cloud-download.683eaf89.svg";